export const TEXTS = {
  ALL_PLATFORMS: "All platforms",
  CLIENT_TYPES: "Client types: ",
  COMPLEX_TARGET: "Complex target",
  NO_TARGET: "No target",
  OEMS: "OEMs: ",
  PLATFORMS: "Platforms: ",
};
